import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { SavingParameters, PeriodTypeEnum, ScheduleDate, FundParameters, FundsLogic } from '@akiba/models_bimbo';
import { AppState } from '../../../models/appState';
import { Subscription } from 'rxjs';
import { UploadService } from '../../../services/upload.service';
import { DataSourceService } from '../../../services/data-source.service';
import { AuthenticationService } from 'projects/bimbo/src/app/services/authentication.service';
import { MatDialog, MatTabChangeEvent, MatSelectChange } from '@angular/material';
import { LogicService } from '../../../services/logic.service';
import { InfoDialogComponent } from '../../../dialogs/info-dialog/info-dialog.component';
import { CancelConfirmDialogComponent } from '../../../dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import * as moment from 'moment';

@Component({
  selector: 'app-saving-fund-parameters',
  templateUrl: './saving-fund-parameters.component.html',
  styleUrls: ['./saving-fund-parameters.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SavingFundParametersComponent implements OnInit, OnDestroy {

  tempPeriod: FundParameters;
  isEdit = false;
  isNew = false;
  fundType = [{ name: 'Fondo Corto', type: 4 }, { name: 'Fondo Largo', type: 5 }];
  selectedType: any = {};
  contentLocation: AppState = new AppState();
  selectedIndex = 0;
  dt = moment();
  minuteReset = this.dt.parseZone().utcOffset();

  uploadSubscription: Subscription = null;
  appLogicChangesSubscription: Subscription = null;

  /////////////////////////////////////////////////////
  fundLogic: FundsLogic;
  /////////////////////////////////////////////////////
  parametersFundSubscription: Subscription | null = null;
  /////////////////////////////////////////////////////

  constructor(public authService: AuthenticationService, private uploadService: UploadService, private dataService: DataSourceService, public dialog: MatDialog, public appLogic: LogicService) {
    this.fundLogic = new FundsLogic(this.dataService);
    this.createNewFundParameter();
  }

  ngOnInit() {
    this.fundLogic.loadParameters();
  }

  keyUpMethod(event: string) {
    if (event) {
      this.isNew = true;
    } else {
      this.isNew = false;
      this.contentLocation.savingParametersIndex = 0;
    }
  }

  tabChanged(event: MatTabChangeEvent): void {
    this.selectedIndex = event.index;
  }

  fundTypeToText(type: number) {
    const t = this.fundType.find(element => element.type === type);
    if (t) {
      return t.name;
    }
    return 'Sin titulo';
  }

  selectedPeriodChange(event: MatSelectChange) {

    if (!event.value) {
      this.createNewFundParameter();
      this.isEdit = false;
      this.tempPeriod = null;
    } else {
      this.fundLogic.modFund = event.value;
      this.isEdit = true;
      this.tempPeriod = event.value;
    }

  }

  selectedTypeChange(event: MatSelectChange) {

    if (event.value) {
      this.fundLogic.modFund.type = event.value.type;
    } else {
      this.fundLogic.modFund.type = 0;
    }

  }

  savePeriod() {
    const authUser = this.appLogic.dataManager.principalDataLoader.employee ? this.appLogic.dataManager.principalDataLoader.employee : this.authService.authEmployee;

    if (this.fundLogic.modFund.type === PeriodTypeEnum.shortSavingFund) {

      if (!this.fundLogic.modFund.fundDates || !this.fundLogic.modFund.fundDates.length) {

        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'Se debe de ingresar al menos una fecha de ciclo.',
            close: 'Aceptar'
          }
        });

        return;

      }

    } else {

      const past = new Date();
      past.setFullYear(1900);

      const pd = new ScheduleDate();
      pd.active = true;
      pd.startDate = past;
      pd.indeterminate = true;

      this.fundLogic.modFund.fundDates.push(pd);

    }

    if (!this.fundLogic.modFund.includedCompanies || !this.fundLogic.modFund.includedCompanies.length) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Se debe de incluir al menos una compañía.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (!this.fundLogic.modFund.title) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El nombre del ciclo es requerido.',
          close: 'Aceptar'
        }
      });

      return;

    }


    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea guardar el ciclo con la información dada?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    dialogConfirmation.afterClosed().subscribe(result => {

      if (result) {
        let createDate = new Date();
        let paramLogs = {
          changeID: '',
          collection: 'fundParameters',
          approvedUid: authUser.uid,
          approvedBy: {
            firstName: authUser.firstName,
            firstLastName: authUser.firstLastName,
            employeeNumber: authUser.workInformation.employeeNumber,
          },
          createDate: createDate,
          timeStamp: createDate.getTime()
        };
          // poner aqui el reset 
          this.resetDates(this.fundLogic.modFund.fundDates);          
        if (this.fundLogic.modFund.fileUploaded.file) {

          this.uploadService.pushUpload(this.fundLogic.modFund.fileUploaded);
          this.uploadSubscription = this.uploadService.downloadURLSubject.subscribe(downloadURL => {

            this.fundLogic.modFund.fileUploaded.file = null;
            this.fundLogic.modFund.fileUploaded.downloadURL = downloadURL;

            if (this.uploadSubscription && !this.uploadSubscription.closed) {
              this.uploadSubscription.unsubscribe();
              this.uploadSubscription = null;
            }
            const aPeriodObj = this.fundLogic.modFund.toAny();
            paramLogs.changeID = aPeriodObj.parametersID;
            this.dataService.saveLogAdministratorActions(paramLogs ,'savingFundFileUploaded');
            this.dataService.saveFundParameter(aPeriodObj).then(() => {
              this.reset();

              this.dialog.open(InfoDialogComponent, {
                data: {
                  message: 'La información ha sido actualizada',
                  close: 'Aceptar'
                }
              });

            });

          });

        } else {

          const aPeriodObj = this.fundLogic.modFund.toAny();
          paramLogs.changeID = aPeriodObj.parametersID;
          this.dataService.saveLogAdministratorActions(paramLogs ,'savingFund');
          this.dataService.saveFundParameter(aPeriodObj).then(() => {

            this.reset();

            this.dialog.open(InfoDialogComponent, {
              data: {
                message: 'La información ha sido actualizada',
                close: 'Aceptar'
              }
            });

          });

        }

      }

    });

  }

  reset() {

    this.createNewFundParameter();
    this.tempPeriod = null;
    this.contentLocation.savingParametersIndex = 0;
    this.isEdit = false;
    this.isNew = false;
    this.selectedType = {};
  }

  cancelPeriodChanges() {

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea descartar los cambios hechos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });
    dialogConfirmation.afterClosed().subscribe(async result => {
      if (result) {
        this.reset();
      }
    });

  }

  createNewFundParameter() {
    const temp = new FundParameters();
    const aDate = new Date();
    temp.parametersID = aDate.getTime().toString();
    this.fundLogic.modFund = temp;
  }

  resetDates(dates: ScheduleDate[]) {
    if (dates.length > 0) {
      
      for (const iterator of dates) {

        let startMoment = moment(iterator.startDate).startOf('day');
        let endMoment = moment(iterator.endDate).startOf('day');
        iterator.startDate = startMoment.add(this.minuteReset, 'minutes').toDate();
        iterator.endDate = endMoment.add(this.minuteReset, 'minutes').toDate();
      }
    }
  }

  ngOnDestroy(): void {

    this.fundLogic.unsubscribe();

    if (this.uploadSubscription && !this.uploadSubscription.closed) {
      this.uploadSubscription.unsubscribe();
      this.uploadSubscription = null;
    }

    if (this.appLogicChangesSubscription && !this.appLogicChangesSubscription.closed) {
      this.appLogicChangesSubscription.unsubscribe();
      this.appLogicChangesSubscription = null;
    }

    if (this.parametersFundSubscription && !this.parametersFundSubscription.closed) {
      this.parametersFundSubscription.unsubscribe();
      this.parametersFundSubscription = null;
    }

  }

}
